import axios from 'axios';

// Trust On First Use (TOFU): read fingerprint from localStorage; if missing, accept first connection
// The backend logs the fingerprint at startup. User copies it once to the frontend store.

// Resolve API base URL dynamically for Cloudflare and other environments
// Priority: window.__API_BASE_URL__ > REACT_APP_API_BASE_URL > same-origin ('')
const dynamicBaseUrl =
  (typeof window !== 'undefined' && window.__API_BASE_URL__) ||
  process.env.REACT_APP_API_BASE_URL ||
  '';

// Fallback for local dev: if no base URL provided, point to HTTPS backend on 127.0.0.1:3001
const inferredDevBase =
  (typeof window !== 'undefined' && dynamicBaseUrl === '' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'))
    ? 'https://127.0.0.1:3001'
    : '';

const api = axios.create({ baseURL: dynamicBaseUrl || inferredDevBase });

// Ensure server's strict JSON+UTF-8 check passes for mutating requests
api.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8';
api.defaults.headers.put['Content-Type'] = 'application/json; charset=utf-8';
api.defaults.headers.patch['Content-Type'] = 'application/json; charset=utf-8';

export default api;

// Attach user id header for local dev so server can route storage by user
api.interceptors.request.use((config) => {
  try {
    // Only attach this header when using the local dev API (https://127.0.0.1:3001)
    const usingLocalDevApi = (typeof window !== 'undefined') && (dynamicBaseUrl === '') &&
      (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
    if (usingLocalDevApi) {
      const stored = typeof window !== 'undefined' ? window.localStorage.getItem('currentUser') : null;
      if (stored) {
        const user = JSON.parse(stored);
        if (user?.id) {
          config.headers['X-User-Id'] = user.id;
        }
      }
    }
  } catch {}
  return config;
});

// Attach Cognito bearer token for all API requests
api.interceptors.request.use((config) => {
  try {
    const stored = typeof window !== 'undefined' ? window.localStorage.getItem('currentUser') : null;
    if (stored) {
      const user = JSON.parse(stored);
      const token = user?.idToken || user?.accessToken;
      if (token) {
        config.headers = config.headers || {};
        config.headers['Authorization'] = `Bearer ${token}`;
      }
    }
  } catch {}
  return config;
});